<ng-container *ngIf="dataLoaded; else loading">
  <div class="container">
    <div class="d-flex justify-content-between align-items-center">
      <div class="row">
        <div class="col-md-10">
          <h2 class="title-header d-flex align-items-center">
            Subject Property
            <!-- approved -->
            <span *ngIf="rowDetails?.latestReview.status === 3" class="ms-2 text-success" title="Approved">
              <i class="fas fa-check-circle"></i>
            </span>
            <!-- rejected -->
            <span *ngIf="rowDetails?.latestReview.status === 4" class="ms-2 text-danger" title="Rejected">
              <i class="fas fa-times-circle"></i>
            </span>
            <!-- pending -->
            <span *ngIf="rowDetails?.latestReview.status !== 3 && rowDetails?.latestReview.status !== 4"
              class="ms-2 text-warning" title="Pending">
              <i class="fas fa-hourglass-half"></i>
            </span>
          </h2>
          <div class="scrollspy-example scrollspy-container">
            <!-- Subject Property Details -->
            <section mdbScrollspyElement="scrollspy" id="Subject-Property">
              <div class="form-section col-md-12">
                <div class="d-flex flex-wrap gap-3">
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 33%;">
                    <label class="form-label">Property Type</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.propertyTypeAndTenancy?.propertyType"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('propertyTypeAndTenancy.propertyType', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('propertyTypeAndTenancy.propertyType', rowDetails).message || null : null" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 33%;">
                    <label class="form-label">Property Subtype</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.propertyTypeAndTenancy?.propertySubtype"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('propertyTypeAndTenancy.propertySubtype', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('propertyTypeAndTenancy.propertySubtype', rowDetails).message || null : null" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 33%;">
                    <label class="form-label">Tenancy</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.propertyTypeAndTenancy?.tenancy"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('propertyTypeAndTenancy.tenancy', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('propertyTypeAndTenancy.tenancy', rowDetails).message || null : null" />
                  </div>
                </div>
              </div>
            </section>

            <!-- Subject Property Location -->
            <section mdbScrollspyElement="scrollspy" id="Location-Info">
              <div class="form-section col-md-12">
                <h4 class="form-header"><i class="fas fa-map-marker-alt fa-fw me-2"></i>Subject Property Location</h4>
                <div class="d-flex flex-wrap gap-3 mt-3">

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Property Name</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.subjectPropertyLocation?.propertyName"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('subjectPropertyLocation.propertyName', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('subjectPropertyLocation.propertyName', rowDetails).message || null : null" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Address</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.subjectPropertyLocation?.addressLine1"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('subjectPropertyLocation.addressLine1', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('subjectPropertyLocation.addressLine1', rowDetails).message || null : null" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">City</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.subjectPropertyLocation?.city"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('subjectPropertyLocation.city', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('subjectPropertyLocation.city', rowDetails).message || null : null" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">County</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.subjectPropertyLocation?.county"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('subjectPropertyLocation.county', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('subjectPropertyLocation.county', rowDetails).message || null : null" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Region</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.subjectPropertyLocation?.region" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">State/Province</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.subjectPropertyLocation?.state"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('subjectPropertyLocation.state', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('subjectPropertyLocation.state', rowDetails).message || null : null" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Zipcode</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.subjectPropertyLocation?.zipCode"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('subjectPropertyLocation.zipCode', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('subjectPropertyLocation.zipCode', rowDetails).message || null : null" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Country</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.subjectPropertyLocation?.country"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('subjectPropertyLocation.country', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('subjectPropertyLocation.country', rowDetails).message || null : null" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">MSA</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.subjectPropertyLocation?.metropolitanStatisticalArea" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Market</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.subjectPropertyLocation?.market" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Submarket</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.subjectPropertyLocation?.submarket" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Latitude</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.subjectPropertyLocation?.latitude"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('subjectPropertyLocation.latitude', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('subjectPropertyLocation.latitude', rowDetails).message || null : null" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Longitude</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.subjectPropertyLocation?.longitude"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('subjectPropertyLocation.longitude', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('subjectPropertyLocation.longitude', rowDetails).message || null : null" />
                  </div>
                </div>
                <div>
                  <div class="flex-grow-1" style="min-width: 250px;">
                    <label class="form-label">Street Location</label>
                    <textarea class="form-control form-control-sm" readonly rows="2" style="resize: none;"
                      [value]="rowDetails?.subjectPropertyLocation?.streetLocation"></textarea>
                  </div>
                </div>
              </div>
            </section>

            <!-- Parcel Information -->
            <section mdbScrollspyElement="scrollspy" id="Parcel-Info">
              <div class="form-section col-md-12">
                <h4 class="form-header">Parcel Information</h4>
                <div class="d-flex flex-wrap gap-4 mt-3">
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 100%;">
                    <label class="form-label">Assessor's Parcel Identification</label>
                    <input type="text" class="form-control form-control-sm text-truncate"
                      style="overflow: hidden; text-overflow: ellipsis;" [readonly]="true"
                      [value]="rowDetails?.parcelInformation?.assessorsParcelNumber"
                      [attr.title]="rowDetails?.parcelInformation?.assessorsParcelNumber" />
                  </div>
                </div>
              </div>
            </section>

            <!-- Site Information -->
            <section mdbScrollspyElement="scrollspy" id="Site-Info">
              <div class="form-section col-md-12">
                <h4 class="form-header">Site Information</h4>

                <div class="d-flex flex-wrap gap-3">
                  <!-- Pivoted Table (Land Area Info) -->
                  <div class="w-100">
                    <div class="table-responsive">
                      <table class="table table-bordered mb-3" style="min-width: 600px;">
                        <thead>
                          <tr>
                            <th style="width: 250px;"></th>
                            <th>Primary</th>
                            <th>Secondary</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Land Area Measure</td>
                            <td><input type="text" class="form-control form-control-sm" [readonly]="true"
                                [value]="toTitleCase(rowDetails?.siteInformation?.primaryLandMeasure)"
                                [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('siteInformation.primaryLandMeasure', rowDetails).valid }"
                                [attr.title]="dataLoaded ? getValidationStatus('siteInformation.primaryLandMeasure', rowDetails).message || null : null" /></td>
                            <td><input type="text" class="form-control form-control-sm" [readonly]="true"
                                [value]="toTitleCase(rowDetails?.siteInformation?.secondaryLandMeasure)"
                                [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('siteInformation.secondaryLandMeasure', rowDetails).valid }"
                                [attr.title]="dataLoaded ? getValidationStatus('siteInformation.secondaryLandMeasure', rowDetails).message || null : null" /></td>
                          </tr>
                          <tr>
                            <td>Land Area/Site Area</td>
                            <td><input type="text" class="form-control form-control-sm" [readonly]="true"
                                [value]="formatValue(rowDetails?.siteInformation?.primaryLandValue, 'LandArea')" 
                                [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('siteInformation.primaryLandValue', rowDetails).valid }"
                                [attr.title]="dataLoaded ? getValidationStatus('siteInformation.primaryLandValue', rowDetails).message || null : null" /></td>
                            <td><input type="text" class="form-control form-control-sm" [readonly]="true"
                                [value]="formatValue(rowDetails?.siteInformation?.secondaryLandValue, 'LandArea')"
                                [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('siteInformation.secondaryLandValue', rowDetails).valid }"
                                [attr.title]="dataLoaded ? getValidationStatus('siteInformation.secondaryLandValue', rowDetails).message || null : null" />
                            </td>
                          </tr>
                          <tr>
                            <td>Excess Land Area</td>
                            <td><input type="text" class="form-control form-control-sm" [readonly]="true"
                                [value]="formatValue(rowDetails?.siteInformation?.primaryLandExcess, 'LandArea')"
                                [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('siteInformation.primaryLandExcess', rowDetails).valid }"
                                [attr.title]="dataLoaded ? getValidationStatus('siteInformation.primaryLandExcess', rowDetails).message || null : null" />
                            </td>
                            <td><input type="text" class="form-control form-control-sm" [readonly]="true"
                                [value]="formatValue(rowDetails?.siteInformation?.secondaryLandExcess, 'LandArea')"
                                [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('siteInformation.secondaryLandExcess', rowDetails).valid }"
                                [attr.title]="dataLoaded ? getValidationStatus('siteInformation.secondaryLandExcess', rowDetails).message || null : null" />
                            </td>
                          </tr>
                          <tr>
                            <td>Unit of Measure</td>
                            <td><input type="text" class="form-control form-control-sm" [readonly]="true"
                                [value]="rowDetails?.siteInformation?.primaryLandUnit" /></td>
                            <td><input type="text" class="form-control form-control-sm" [readonly]="true"
                                [value]="rowDetails?.siteInformation?.secondaryLandUnit" /></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <!-- Aligned Fields (3 columns in a row) -->
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Shape</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.siteInformation?.shape" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Topography</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.siteInformation?.topography"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('siteInformation.topography', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('siteInformation.topography', rowDetails).message || null : null" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Access</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.siteInformation?.access" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Visibility</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.siteInformation?.visibility" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Frontage</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.siteInformation?.frontage" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Public Utilities</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.siteInformation?.utility" />
                  </div>

                  <div class="w-100">
                    <label class="form-label">Site Improvements</label>
                    <textarea class="form-control form-control-sm" readonly rows="2" style="resize: none;"
                      [value]="rowDetails?.siteInformation?.siteImprovements.trim()">
                    </textarea>
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Ground Leases</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.siteInformation?.groundLeases"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('siteInformation.groundLeases', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('siteInformation.groundLeases', rowDetails).message || null : null" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Ground Lease Description</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.siteInformation?.groundLeaseDescription"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('siteInformation.groundLeaseDescription', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('siteInformation.groundLeaseDescription', rowDetails).message || null : null" />
                  </div>

                  <!-- Utilities -->
                  <div class="flex-grow-1" style="min-width: 250px;">
                    <label class="form-label">Utilities</label>
                    <div class="d-flex flex-wrap gap-3">
                      <!-- Pivoted Table (Land Area Info) -->
                      <div class="w-100">
                        <div class="table-responsive">
                          <table class="table table-bordered mb-3" style="min-width: 600px;">
                            <thead>
                              <tr>
                                <th style="width: 250px;"></th>
                                <th>Paid By</th>
                                <th>Provider</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Electric</td>
                                <td><input type="text" class="form-control form-control-sm" [readonly]="true"
                                    [value]="rowDetails.siteInformation?.electric?.paidBy"
                                    [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('siteInformation.electric.paidBy', rowDetails).valid }"
                                    [attr.title]="dataLoaded ? getValidationStatus('siteInformation.electric.paidBy', rowDetails).message || null : null" />
                                </td>
                                <td><input type="text" class="form-control form-control-sm" [readonly]="true"
                                    [value]="rowDetails.siteInformation?.electric?.provider" /></td>
                              </tr>
                              <tr>
                                <td>Gas</td>
                                <td><input type="text" class="form-control form-control-sm" [readonly]="true"
                                    [value]="rowDetails.siteInformation?.gas?.paidBy"
                                    [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('siteInformation.gas.paidBy', rowDetails).valid }"
                                    [attr.title]="dataLoaded ? getValidationStatus('siteInformation.gas.paidBy', rowDetails).message || null : null" />
                                </td>
                                <td><input type="text" class="form-control form-control-sm" [readonly]="true"
                                    [value]="rowDetails.siteInformation?.gas?.provider" /></td>
                              </tr>
                              <tr>
                                <td>Refuse</td>
                                <td><input type="text" class="form-control form-control-sm" [readonly]="true"
                                    [value]="rowDetails.siteInformation?.refuse?.paidBy"
                                    [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('siteInformation.refuse.paidBy', rowDetails).valid }"
                                    [attr.title]="dataLoaded ? getValidationStatus('siteInformation.refuse.paidBy', rowDetails).message || null : null" />
                                </td>
                                <td><input type="text" class="form-control form-control-sm" [readonly]="true"
                                    [value]="rowDetails.siteInformation?.refuse?.provider" /></td>
                              </tr>
                              <tr>
                                <td>Sewer</td>
                                <td><input type="text" class="form-control form-control-sm" [readonly]="true"
                                    [value]="rowDetails.siteInformation?.sewer?.paidBy"
                                    [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('siteInformation.sewer.paidBy', rowDetails).valid }"
                                    [attr.title]="dataLoaded ? getValidationStatus('siteInformation.sewer.paidBy', rowDetails).message || null : null" />
                                </td>
                                <td><input type="text" class="form-control form-control-sm" [readonly]="true"
                                    [value]="rowDetails.siteInformation?.sewer?.provider" /></td>
                              </tr>
                              <tr>
                                <td>Water</td>
                                <td><input type="text" class="form-control form-control-sm" [readonly]="true"
                                    [value]="rowDetails.siteInformation?.water?.paidBy"
                                    [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('siteInformation.water.paidBy', rowDetails).valid }"
                                    [attr.title]="dataLoaded ? getValidationStatus('siteInformation.water.paidBy', rowDetails).message || null : null" />
                                </td>
                                <td><input type="text" class="form-control form-control-sm" [readonly]="true"
                                    [value]="rowDetails.siteInformation?.water?.provider" /></td>
                              </tr>
                              <tr>
                                <td>Telephone</td>
                                <td><input type="text" class="form-control form-control-sm" [readonly]="true"
                                    [value]="rowDetails.siteInformation?.telephone?.paidBy"
                                    [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('siteInformation.telephone.paidBy', rowDetails).valid }"
                                    [attr.title]="dataLoaded ? getValidationStatus('siteInformation.telephone.paidBy', rowDetails).message || null : null" />
                                </td>
                                <td><input type="text" class="form-control form-control-sm" [readonly]="true"
                                    [value]="rowDetails.siteInformation?.telephone?.provider" /></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <!-- Ownership -->
            <section mdbScrollspyElement="scrollspy" id="Ownership">
              <div class="form-section col-md-12">
                <h4 class="form-header">Ownership</h4>

                <div class="d-flex flex-wrap gap-3 mt-3">

                  <!-- Aligned Fields (3 columns in a row) -->
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Property Ownership Entity</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.ownership?.propertyOwnershipEntity" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Sold In Last Three Years</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.ownership?.soldInLastThreeYears" 
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('ownership.soldInLastThreeYears', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('ownership.soldInLastThreeYears', rowDetails).message || null : null" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Sale Date</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.ownership?.saleDate" 
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('ownership.saleDate', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('ownership.saleDate', rowDetails).message || null : null" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Sale Price</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.ownership?.salePrice"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('ownership.salePrice', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('ownership.salePrice', rowDetails).message || null : null" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">List Price</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.ownership?.listPrice" 
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('ownership.listPrice', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('ownership.listPrice', rowDetails).message || null : null" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Contract Price</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.ownership?.contractPrice"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('ownership.contractPrice', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('ownership.contractPrice', rowDetails).message || null : null" />
                  </div>                  
                </div>
              </div>
            </section>

            <!-- Site Conditions -->
            <section mdbScrollspyElement="scrollspy" id="Site-Conditions">
              <div class="form-section col-md-12">
                <h4 class="form-header">Site Conditions</h4>

                <div class="d-flex flex-wrap gap-3 mt-3">
                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Soil Conditions</label>
                    <textarea class="form-control form-control-sm" rows="4" [readonly]="true"
                      [value]="rowDetails?.siteConditions?.soilConditions?.trim()"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('siteConditions.soilConditions', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('siteConditions.soilConditions', rowDetails).message || null : null">
                    </textarea>
                  </div>

                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Land Use Restrictions</label>
                    <textarea class="form-control form-control-sm" rows="4" [readonly]="true"
                      [value]="rowDetails?.siteConditions?.landUseRestrictions?.trim()"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('siteConditions.landUseRestrictions', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('siteConditions.landUseRestrictions', rowDetails).message || null : null">
                    </textarea>
                  </div>

                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Wetlands</label>
                    <textarea class="form-control form-control-sm" rows="4" [readonly]="true"
                      [value]="rowDetails?.siteConditions?.wetlands?.trim()"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('siteConditions.wetlands', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('siteConditions.wetlands', rowDetails).message || null: null">
                    </textarea>
                  </div>

                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Hazardous Substances</label>
                    <textarea class="form-control form-control-sm" rows="4" [readonly]="true"
                      [value]="rowDetails?.siteConditions?.hazardousSubstances?.trim()"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('siteConditions.hazardousSubstances', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('siteConditions.hazardousSubstances', rowDetails).message || null: null">
                    </textarea>
                  </div>

                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Overall Utility</label>
                    <textarea class="form-control form-control-sm" rows="4" [readonly]="true"
                      [value]="rowDetails?.siteConditions?.overallUtility?.trim()"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('siteConditions.overallUtility', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('siteConditions.overallUtility', rowDetails).message || null : null">
                    </textarea>
                  </div>

                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Summary</label>
                    <textarea class="form-control form-control-sm" rows="4" [readonly]="true"
                      [value]="rowDetails?.siteConditions?.summary?.trim()"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('siteConditions.summary', rowDetails).valid }"
                      [attr.title]="dataLoaded ?getValidationStatus('siteConditions.summary', rowDetails).message || null : null">
                    </textarea>
                  </div>
                </div>
              </div>
            </section>

            <!-- Flood Zone Information -->
            <section mdbScrollspyElement="scrollspy" id="Flood-Zone">
              <div class="form-section col-md-12">
                <h4 class="form-header"><i class="fas fa-water fa-fw me-2"></i>Flood Zone Information</h4>
                <div class="d-flex flex-wrap gap-3 mt-3">

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Flood Map Number</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.floodZoneInformation?.floodMapNumber" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Flood Map Date</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="formatValue(rowDetails?.floodZoneInformation?.floodMapDate, 'FloodMapDate')" 
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('floodZoneInformation.floodMapDate', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('floodZoneInformation.floodMapDate', rowDetails).message || null : null"/>
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Flood Zone</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.floodZoneInformation?.floodZone"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('floodZoneInformation.floodZone', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('floodZoneInformation.floodZone', rowDetails).message || null : null" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 300px; max-width: 66%;">
                    <label class="form-label">Flood Zone Comment</label>
                    <textarea class="form-control form-control-sm" readonly rows="2" style="resize: none;"
                      [value]="rowDetails?.floodZoneInformation?.floodZoneComment">
                    </textarea>
                  </div>
                </div>
              </div>
            </section>

            <!-- Improvement Information -->
            <section mdbScrollspyElement="scrollspy" id="Improvement-Info">
              <div class="form-section col-md-12">
                <h4 class="form-header">
                  <i class="fas fa-building fa-fw me-2"></i>Improvement Information
                </h4>

                <!-- Table Block (same as before) -->
                <div class="table-responsive my-3" style="overflow-x: auto; white-space: nowrap;">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th style="padding: 0.25rem 0.5rem; font-size: 0.85rem; width: 200px;"></th>
                        <th>Primary</th>
                        <th>Secondary</th>
                        <th>Tertiary</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Improvement Area Measure</td>
                        <td><input type="text" class="form-control form-control-sm" readonly
                            [value]="toTitleCase(rowDetails?.improvementInformation?.primaryImprovementMeasure)"
                            [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('improvementInformation.primaryImprovementMeasure', rowDetails).valid }"
                            [attr.title]="dataLoaded ? getValidationStatus('improvementInformation.primaryImprovementMeasure', rowDetails).message || null : null" />
                        </td>
                        <td><input type="text" class="form-control form-control-sm" readonly
                            [value]="toTitleCase(rowDetails?.improvementInformation?.secondaryImprovementMeasure)"
                            [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('improvementInformation.secondaryImprovementMeasure', rowDetails).valid }"
                            [attr.title]="dataLoaded ? getValidationStatus('improvementInformation.secondaryImprovementMeasure', rowDetails).message || null : null" />
                        </td>
                        <td><input type="text" class="form-control form-control-sm" readonly
                            [value]="toTitleCase(rowDetails?.improvementInformation?.tertiaryImprovementMeasure)"
                            [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('improvementInformation.tertiaryImprovementMeasure', rowDetails).valid }"
                            [attr.title]="dataLoaded ? getValidationStatus('improvementInformation.tertiaryImprovementMeasure', rowDetails).message || null : null" />
                        </td>
                      </tr>

                      <tr>
                        <td>Improvement Area</td>
                        <td>
                          <input type="text" class="form-control form-control-sm mb-1" readonly title="Current"
                            [value]="formatValue(rowDetails?.improvementInformation?.primaryImprovementValue, 'ImprovementArea')"
                            [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('improvementInformation.primaryImprovementValue', rowDetails).valid }"
                            [attr.title]="dataLoaded ? getValidationStatus('improvementInformation.primaryImprovementValue', rowDetails).message || null : null" />
                          <input type="text" class="form-control form-control-sm mb-1" readonly title="Prior"
                            style="background-color: #e9ecef;"
                            [value]="getFormattedPrior(rowDetails?.improvementInformation?.primaryImprovementPriorValue, 'ImprovementArea')"
                            [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('improvementInformation.primaryImprovementPriorValue', rowDetails).valid }"
                            [attr.title]="dataLoaded ? getValidationStatus('improvementInformation.primaryImprovementPriorValue', rowDetails).message || null : null" />
                          <input type="text" class="form-control form-control-sm text-white bg-info" readonly
                            title="Delta ((Current - Prior)/ Prior * 100)" [value]="getFormattedDelta(
                              rowDetails?.improvementInformation?.primaryImprovementValue,
                              rowDetails?.improvementInformation?.primaryImprovementPriorValue, 'ImprovementArea')" />
                        </td>
                        <td>
                          <input type="text" class="form-control form-control-sm mb-1" readonly title="Current"
                            [value]="formatValue(rowDetails?.improvementInformation?.secondaryImprovementValue, 'ImprovementArea')"
                            [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('improvementInformation.secondaryImprovementValue', rowDetails).valid }"
                            [attr.title]="dataLoaded ? getValidationStatus('improvementInformation.secondaryImprovementValue', rowDetails).message || null : null" />
                          <input type="text" class="form-control form-control-sm mb-1" readonly title="Prior"
                            style="background-color: #e9ecef;"
                            [value]="getFormattedPrior(rowDetails?.improvementInformation?.secondaryImprovementPriorValue, 'ImprovementArea')"
                            [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('improvementInformation.secondaryImprovementPriorValue', rowDetails).valid }"
                            [attr.title]="dataLoaded ? getValidationStatus('improvementInformation.secondaryImprovementPriorValue', rowDetails).message || null : null"/>
                          <input type="text" class="form-control form-control-sm text-white bg-info" readonly
                            title="Delta ((Current - Prior)/ Prior * 100)"
                            [value]="getFormattedDelta(
                              rowDetails?.improvementInformation?.secondaryImprovementValue,
                              rowDetails?.improvementInformation?.secondaryImprovementPriorValue, 'ImprovementArea')" />
                        </td>
                        <td>
                          <input type="text" class="form-control form-control-sm mb-1" readonly title="Current"
                            [value]="formatValue(rowDetails?.improvementInformation?.tertiaryImprovementValue, 'ImprovementArea')"
                            [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('improvementInformation.tertiaryImprovementValue', rowDetails).valid }"
                            [attr.title]="dataLoaded ? getValidationStatus('improvementInformation.tertiaryImprovementValue', rowDetails).message || null : null" />
                          <input type="text" class="form-control form-control-sm mb-1" readonly title="Prior"
                            style="background-color: #e9ecef;"
                            [value]="getFormattedPrior(rowDetails?.improvementInformation?.tertiaryImprovementPriorValue, 'ImprovementArea')"
                            [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('improvementInformation.tertiaryImprovementPriorValue', rowDetails).valid }"
                            [attr.title]="dataLoaded ? getValidationStatus('improvementInformation.tertiaryImprovementPriorValue', rowDetails).message || null : null" />
                          <input type="text" class="form-control form-control-sm text-white bg-info" readonly
                            title="Delta ((Current - Prior)/ Prior * 100)" [value]="getFormattedDelta(
                              rowDetails?.improvementInformation?.tertiaryImprovementValue,
                              rowDetails?.improvementInformation?.tertiaryImprovementPriorValue, 'ImprovementArea')" />
                        </td>
                      </tr>

                      <tr>
                        <td>Unit of Measure</td>
                        <td><input type="text" class="form-control form-control-sm" readonly
                            [value]="toTitleCase(rowDetails?.improvementInformation?.primaryImprovementUnit)" /></td>
                        <td><input type="text" class="form-control form-control-sm" readonly
                            [value]="toTitleCase(rowDetails?.improvementInformation?.secondaryImprovementUnit)" /></td>
                        <td><input type="text" class="form-control form-control-sm" readonly
                            [value]="toTitleCase(rowDetails?.improvementInformation?.tertiaryImprovementUnit)" /></td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Additional Fields -->
                <div class="d-flex flex-wrap gap-3">

                  <!-- Left Column: Year Built + Year Renovated -->
                  <div class="flex-grow-1" style="min-width: 280px; max-width: 48%;">
                    <label class="form-label">Year Built</label>
                    <input type="text" class="form-control form-control-sm" readonly
                      [value]="rowDetails?.improvementInformation?.yearBuilt"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('improvementInformation.yearBuilt', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('improvementInformation.yearBuilt', rowDetails).message || null : null" />

                    <label class="form-label mt-2">Year Last Renovated</label>
                    <input type="text" class="form-control form-control-sm" readonly
                      [value]="rowDetails?.improvementInformation?.yearRenovated"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('improvementInformation.yearRenovated', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('improvementInformation.yearRenovated', rowDetails).message || null : null" />
                  </div>



                  <!-- Right Column: Occupancy + Vacancy (structured row-wise) -->
                  <div class="flex-grow-1" style="min-width: 280px; max-width: 48%;">
                    <label class="form-label">Occupancy (%)</label>
                    <div class="d-flex gap-2">
                      <input type="text" class="form-control form-control-sm" readonly title="Current"
                        [value]="formatValue(rowDetails?.improvementInformation?.occupancy, 'Occupancy')"
                        [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('improvementInformation.occupancy', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('improvementInformation.occupancy', rowDetails).message || null : null" />
                      <input type="text" class="form-control form-control-sm" readonly
                        style="background-color: #e9ecef;" title="Prior"
                        [value]="getFormattedPrior(rowDetails?.improvementInformation?.priorOccupancy, 'Occupancy')"
                        [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('improvementInformation.priorOccupancy', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('improvementInformation.priorOccupancy', rowDetails).message || null : null" />
                      <input type="text" class="form-control form-control-sm text-white bg-info" readonly
                        title="Delta ((Current - Prior)/ Prior * 100)" [value]="getFormattedDelta(
                          rowDetails?.improvementInformation?.occupancy,
                          rowDetails?.improvementInformation?.priorOccupancy, 'Occupancy')" />
                    </div>

                    <label class="form-label mt-2">Vacancy (%)</label>
                    <div class="d-flex gap-2">
                      <input type="text" class="form-control form-control-sm" readonly title="Current"
                        [value]="formatValue(rowDetails?.improvementInformation?.vacancy, 'Vacancy')" 
                        [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('improvementInformation.vacancy', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('improvementInformation.vacancy', rowDetails).message || null : null" />
                      <input type="text" class="form-control form-control-sm" readonly
                        style="background-color: #e9ecef;" title="Prior"
                        [value]="getFormattedPrior(rowDetails?.improvementInformation?.priorVacancy, 'Vacancy')" />
                      <input type="text" class="form-control form-control-sm text-white bg-info" readonly
                        title="Delta ((Current - Prior)/ Prior * 100)" [value]="getFormattedDelta(
                          rowDetails?.improvementInformation?.vacancy,
                          rowDetails?.improvementInformation?.priorVacancy ,'Vacancy')" />
                    </div>
                  </div>

                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Number of Buildings</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.improvementInformation?.numberOfBuildings"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('improvementInformation.numberOfBuildings', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('improvementInformation.numberOfBuildings', rowDetails).message || null : null" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Number of Stories</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.improvementInformation?.numberOfStories"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('improvementInformation.numberOfStories', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('improvementInformation.numberOfStories', rowDetails).message || null : null" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Property Class</label>
                    <input type="text" class="form-control form-control-sm text-truncate" [readonly]="true"
                      [value]="rowDetails?.improvementInformation?.propertyClass" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Effective Age</label>
                    <input type="text" class="form-control form-control-sm text-truncate" [readonly]="true"
                      [value]="rowDetails?.improvementInformation?.effectiveAge"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('improvementInformation.effectiveAge', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('improvementInformation.effectiveAge', rowDetails).message || null : null" />
                  </div>

                  <!-- BUDS -->
                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Economic Life</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.improvementInformation?.economicLife"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('improvementInformation.economicLife', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('improvementInformation.economicLife', rowDetails).message || null : null" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Remaining Economic Life</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="toNumber(rowDetails?.improvementInformation?.economicLife) - toNumber(rowDetails?.improvementInformation?.effectiveAge)" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Building Condition</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.improvementInformation?.buildingCondition" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Building Quality</label>
                    <input type="text" class="form-control form-control-sm text-truncate" [readonly]="true"
                      [value]="rowDetails?.improvementInformation?.buildingQuality" />
                  </div>                           
                  <!---------->
                </div>
              </div>
            </section>

            <!-- Improvement Information - Industrial -->
            <section mdbScrollspyElement="scrollspy" id="Improvement-Info-Industrial">
              <div class="form-section col-md-12">
                <h4 class="form-header">
                  <i class="fas fa-industry fa-fw me-2"></i>Improvement Information - Industrial
                </h4>
                <div class="d-flex flex-wrap gap-3 mt-3">
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Percent Office Space</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.improvementInformationIndustrial?.percentOfficeSpace"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('improvementInformationIndustrial.percentOfficeSpace', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('improvementInformationIndustrial.percentOfficeSpace', rowDetails).message || null : null" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Clear Ceiling Height</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.improvementInformationIndustrial?.clearCeilingHeight" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Number of Dock-High Doors</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.improvementInformationIndustrial?.numberOfDockHighDoors" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Number of Drive-In Doors</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.improvementInformationIndustrial?.numberOfDriveInDoors" />
                  </div>
                </div>
              </div>
            </section>

            <!-- Improvement Information - Living -->
            <section mdbScrollspyElement="scrollspy" id="Improvement-Info-Living">
              <div class="form-section col-md-12">
                <h4 class="form-header">
                  <i class="fas fa-home fa-fw me-2"></i>Improvement Information - Living
                </h4>
                <div class="d-flex flex-wrap gap-3 mt-3">
                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Number of Units</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.improvementInformationLiving?.numberOfUnits" />
                  </div>                
                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Project Amenities</label>
                    <textarea class="form-control form-control-sm" readonly rows="2" style="resize: none;"
                      [value]="rowDetails?.improvementInformationLiving?.projectAmenities">
                    </textarea>
                  </div>
                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Unit Amenities</label>
                    <textarea class="form-control form-control-sm" readonly rows="2" style="resize: none;"
                      [value]="rowDetails?.improvementInformationLiving?.unitAmenities">
                    </textarea>
                  </div>                
                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Land Ownership Interest</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.improvementInformationLiving?.landOwnershipInterest"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('improvementInformationLiving.landOwnershipInterest', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('improvementInformationLiving.landOwnershipInterest', rowDetails).message || null : null" />
                  </div>
                </div>
              </div>
            </section>

            <!-- Improvement Information - Retail -->
            <section mdbScrollspyElement="scrollspy" id="Improvement-Info-Retail">
              <div class="form-section col-md-12">
                <h4 class="form-header">
                  <i class="fas fa-home fa-fw me-2"></i>Improvement Information - Retail
                </h4>
                <div class="d-flex flex-wrap gap-3 mt-3">
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Number of Anchors</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.improvementInformationRetail?.numberOfAnchors" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Total Anchors Area</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.improvementInformationRetail?.totalAnchorsArea" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Total Anchors Gross Leasable Area %</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.improvementInformationRetail?.totalAnchorsGrossLeasableAreaPercentage" />
                  </div>
                </div>
              </div>
            </section>

            <!-- Construction Details -->
            <section mdbScrollspyElement="scrollspy" id="Construction-Details">
              <div class="form-section col-md-12">
                <h4 class="form-header">
                  <i class="fas fa-tools fa-fw me-2"></i>Construction Details
                </h4>
                <div class="d-flex flex-wrap gap-3 mt-3">
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Basic Construction</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.constructionDetails?.basicConstruction" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Construction Status</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.constructionDetails?.constructionStatus" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Exterior Walls</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.constructionDetails?.exteriorWalls" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Roof Type</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.constructionDetails?.roofType" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Roof Surface</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.constructionDetails?.roofSurface" />
                  </div>                  
                </div>
              </div>
            </section>

            <section mdbScrollspyElement="scrollspy" id="Mechanical-Details">
              <div class="form-section col-md-12">
                <h4 class="form-header"><i class="fas fa-wind fa-fw me-2"></i>Mechanical Details</h4>
                <div class="d-flex flex-wrap gap-3 mt-3">
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">HVAC</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.mechanicalDetails?.hvac"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('mechanicalDetails.hvac', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('mechanicalDetails.hvac', rowDetails).message || null : null" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Fire Protection</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.mechanicalDetails?.fireProtection" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Security</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.mechanicalDetails?.security" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Number of Passenger Elevators</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.mechanicalDetails?.numberofPassengerElevators"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('mechanicalDetails.numberofPassengerElevators', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('mechanicalDetails.numberofPassengerElevators', rowDetails).message || null : null" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Number of Freight Elevators</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.mechanicalDetails?.numberofFreightElevators"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('mechanicalDetails.numberofFreightElevators', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('mechanicalDetails.numberofFreightElevators', rowDetails).message || null : null" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Number of Elevators</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"                      
                      [value]="toNumber(rowDetails?.mechanicalDetails?.numberofPassengerElevators) + toNumber(rowDetails?.mechanicalDetails?.numberofFreightElevators)"/>
                  </div>
                </div>
              </div>
            </section>

            <!-- Parking -->
            <section mdbScrollspyElement="scrollspy" id="Parking">
              <div class="form-section col-md-12">
                <h4 class="form-header">
                  <i class="fas fa-parking fa-fw me-2"></i>Parking
                </h4>
                <div class="table-responsive mt-3">
                  <table class="table table-sm table-bordered text-center align-middle">
                    <thead class="table-secondary">
                      <tr>
                        <th>Type</th>
                        <th>Number of Spaces</th>
                        <th>Living Sectors</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{ rowDetails?.parking?.parkingTypeOne }}</td>
                        <td>{{ rowDetails?.parking?.parkingTypeOneNoOfSpaces }}</td>
                        <td>{{ rowDetails?.parking?.parkingTypeOneLivingSectors }}</td>
                      </tr>
                      <tr>
                        <td>{{ rowDetails?.parking?.parkingTypeTwo }}</td>
                        <td>{{ rowDetails?.parking?.parkingTypeTwoNoOfSpaces }}</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>{{ rowDetails?.parking?.parkingTypeThree }}</td>
                        <td>{{ rowDetails?.parking?.parkingTypeThreeNoOfSpaces }}</td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </section>


            <!-- Taxes -->
            <section mdbScrollspyElement="scrollspy" id="Taxes">
              <div class="form-section col-md-12">
                <h4 class="form-header"><i class="fas fa-money-bill-wave fa-fw me-2"></i>Taxes</h4>
                <div class="d-flex flex-wrap gap-3 mt-3">
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Current Tax Year</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.taxes?.currentTaxYear"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('taxes.currentTaxYear', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('taxes.currentTaxYear', rowDetails).message || null : null" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Assessment Ratio (% of market Value)</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.taxes?.assessmentRatio"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('taxes.assessmentRatio', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('taxes.assessmentRatio', rowDetails).message || null : null" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Equalization Rate</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.taxes?.equalizationRate"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('taxes.equalizationRate', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('taxes.equalizationRate', rowDetails).message || null : null" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Are Taxes Current?</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.taxes?.areTaxesCurrent" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Is There a Grievance Underway?</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.taxes?.isThereAGrievanceUnderway" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">The Subject's Assessment and Taxes Are</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.taxes?.theSubjectsAssessmentAndTaxesAre" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Total Tax Rate (%)</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.taxes?.totalTaxRate"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('taxes.totalTaxRate', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('taxes.totalTaxRate', rowDetails).message || null : null" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Total Property Taxes</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.taxes?.totalPropertyTaxes"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('taxes.totalPropertyTaxes', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('taxes.totalPropertyTaxes', rowDetails).message || null : null" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Month Taxes Due without Penalty</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.taxes?.monthTaxesDueWithoutPenalty" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Percent Discount If the Tax Bill Paid by December</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.taxes?.percentDiscountIfTaxBillPaidByDecember"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('taxes.percentDiscountIfTaxBillPaidByDecember', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('taxes.percentDiscountIfTaxBillPaidByDecember', rowDetails).message || null : null" />
                  </div>
                  <!--BUDS-->
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Total Tax Exemptions</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.taxes?.totalTaxExemptions" 
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('taxes.totalTaxExemptions', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('taxes.totalTaxExemptions', rowDetails).message || null : null"/>
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Total Assessed Value</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.taxes?.totalAssessedValue" 
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('taxes.totalAssessedValue', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('taxes.totalAssessedValue', rowDetails).message || null : null"/>
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Improvements Assessed Value</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.taxes?.improvementsAssessedValue" 
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('taxes.improvementsAssessedValue', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('taxes.improvementsAssessedValue', rowDetails).message || null : null"/>
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Land Assessed Value</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.taxes?.landAssessedValue" 
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('taxes.landAssessedValue', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('taxes.landAssessedValue', rowDetails).message || null : null"/>
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Assessor's Market Value</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.taxes?.assessorsMarketValue" 
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('taxes.assessorsMarketValue', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('taxes.assessorsMarketValue', rowDetails).message || null : null"/>
                  </div>
                  <!---->
                </div>
              </div>
            </section>

            <!-- Zoning -->
            <section mdbScrollspyElement="scrollspy" id="Zoning">
              <div class="form-section col-md-12">
                <h4 class="form-header"><i class="fas fa-map-signs fa-fw me-2"></i>Zoning</h4>
                <div class="d-flex flex-wrap gap-3 mt-3">
                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Current Zoning</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.zoning?.currentZoning"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('zoning.currentZoning', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('zoning.currentZoning', rowDetails).message || null : null" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Is Current Use Permitted?</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.zoning?.isCurrentUsePermitted"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('zoning.isCurrentUsePermitted', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('zoning.isCurrentUsePermitted', rowDetails).message || null : null" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Permitted Uses</label>
                    <textarea class="form-control form-control-sm" rows="4" [readonly]="true"
                      [value]="rowDetails?.zoning?.permittedUses"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('zoning.permittedUses', rowDetails).valid }"
                      [attr.title]="rowDetails?.zoning?.permittedUses">
                    </textarea>
                  </div>

                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Prohibited Uses</label>
                    <textarea class="form-control form-control-sm" rows="4" [readonly]="true"
                      [value]="rowDetails?.zoning?.prohibitedUses"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('zoning.prohibitedUses', rowDetails).valid }"
                      [attr.title]="rowDetails?.zoning?.prohibitedUses">
                    </textarea>
                  </div>

                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Zoning Conformance</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.zoning?.zoningConformance"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('zoning.zoningConformance', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('zoning.zoningConformance', rowDetails).message || null : null" />
                  </div>
                </div>
              </div>
            </section>

            <!-- Construction Costs -->
            <section mdbScrollspyElement="scrollspy" id="ConstructionCosts">
              <div class="form-section col-md-12">
                <h4 class="form-header"><i class="fas fa-map-signs fa-fw me-2"></i>Construction Costs</h4>
                <div class="d-flex flex-wrap gap-3 mt-3">
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Soft Costs</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.constructionCosts?.softCosts"                      
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('constructionCosts.softCosts', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('constructionCosts.softCosts', rowDetails).message || null : null" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Furniture Fixtures and Equipment</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.constructionCosts?.furnitureFixturesandEquipment"                     
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('constructionCosts.furnitureFixturesandEquipment', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('constructionCosts.furnitureFixturesandEquipment', rowDetails).message || null : null"/>
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Site Improvement Cost</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.constructionCosts?.siteImprovementCost"                     
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('constructionCosts.siteImprovementCost', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('constructionCosts.siteImprovementCost', rowDetails).message || null : null"/>
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Building Improvement Costs</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.constructionCosts?.buildingImprovementCosts"                     
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('constructionCosts.buildingImprovementCosts', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('constructionCosts.buildingImprovementCosts', rowDetails).message || null : null"/>
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Total Entrepreneurial Profit</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.constructionCosts?.totalEntrepreneurialProfit"                     
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('constructionCosts.totalEntrepreneurialProfit', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('constructionCosts.totalEntrepreneurialProfit', rowDetails).message || null : null"/>
                  </div>
                </div>
              </div>
            </section>

            <!-- Valuations-->
            <section mdbScrollspyElement="scrollspy" id="Valuations">
              <div class="form-section col-md-12">
                <h4 class="form-header"><i class="fas fa-file-alt fa-fw me-2"></i>Valuations</h4>
                <div class="d-flex flex-wrap gap-3 mt-3">
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Currency</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.valuations?.currency" 
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('valuations.currency', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('valuations.currency', rowDetails).message || null : null"/>
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Date Of Report</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="formatValue(rowDetails?.valuations?.dateOfReport, 'DateOfReport')"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('valuations.dateOfReport', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('valuations.dateOfReport', rowDetails).message || null : null" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Date Of Inspection</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="formatValue(rowDetails?.valuations?.dateOfInspection, 'DateOfInspection')"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('valuations.dateOfInspection', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('valuations.dateOfInspection', rowDetails).message || null : null" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">FIRREA</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.valuations?.firrea" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">USPAP/CUSPAP Compliant</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.valuations?.isUSPAPCompliant" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Stabilized</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.valuations?.stabilized" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Client Ownership %</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="getPercentageFormatted(rowDetails?.valuations?.clientOwnership)"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('valuations.clientOwnership', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('valuations.clientOwnership', rowDetails).message || null : null" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Partner</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.valuations?.partner" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Previously Appraised</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.valuations?.previouslyAppraised" />
                  </div>
                </div>
              </div>
            </section>

            <!-- Cash Flow Model (New) -->
            <section mdbScrollspyElement="scrollspy" id="Cash-Flow-Model">
              <div class="form-section col-md-12">
                <h4 class="form-header"><i class="fas fa-chart-bar fa-fw me-2"></i>Cash Flow - Model References</h4>
                <div class="d-flex flex-wrap gap-3 mt-3">
                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Cash Flow Model Type</label>
                    <input type="text" class="form-control form-control-sm text-truncate" [readonly]="true"
                      [value]="rowDetails?.cashFlowModel?.cashFlowModelName"
                      [attr.title]="rowDetails?.cashFlowModel?.cashFlowModelName"
                      style="overflow: hidden; text-overflow: ellipsis;" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Portfolio Name</label>
                    <input type="text" class="form-control form-control-sm text-truncate" [readonly]="true"
                      [value]="rowDetails?.cashFlowModel?.portfolioName"
                      [attr.title]="rowDetails?.cashFlowModel?.portfolioName"
                      style="overflow: hidden; text-overflow: ellipsis;" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Scenario Name</label>
                    <input type="text" class="form-control form-control-sm text-truncate" [readonly]="true"
                      [value]="rowDetails?.cashFlowModel?.scenarioName"
                      [attr.title]="rowDetails?.cashFlowModel?.scenarioName"
                      style="overflow: hidden; text-overflow: ellipsis;" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Property Name</label>
                    <input type="text" class="form-control form-control-sm text-truncate" [readonly]="true"
                      [value]="rowDetails?.cashFlowModel?.propertyName"
                      [attr.title]="rowDetails?.cashFlowModel?.propertyName"
                      style="overflow: hidden; text-overflow: ellipsis;" />
                  </div>
                </div>
              </div>
            </section>

            <!-- Tenant Information -->
            <section mdbScrollspyElement="scrollspy" id="Tenant-Information">
              <div class="form-section col-md-12">
                <h4 class="form-header"><i class="fas fa-users fa-fw me-2"></i>Tenant Information</h4>
                <div class="d-flex flex-wrap gap-3 mt-3">
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Largest Tenant</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.tenantInformation?.largestTenant"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('tenantInformation.largestTenant', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('tenantInformation.largestTenant', rowDetails).message || null : null" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Largest Tenant Area (SF)</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.tenantInformation?.largestTenantArea"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('tenantInformation.largestTenantArea', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('tenantInformation.largestTenantArea', rowDetails).message || null : null" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Largest Tenant Area (%)</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="getLargestTenantAreaPercentage(rowDetails)" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Largest Tenant Lease Expires</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.tenantInformation?.leaseExpires"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('tenantInformation.leaseExpires', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('tenantInformation.leaseExpires', rowDetails).message || null : null" />
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Avg expiries for yr 1-5 % (Per Annum)</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.tenantInformation?.avgExpiries"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('tenantInformation.leaseExpires', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('tenantInformation.leaseExpires', rowDetails).message || null : null" />
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Number of Tenants</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.tenantInformation?.numberOfTenants" />
                  </div>
                </div>
              </div>
            </section>

            <!-- Cashflow (Net Operating Income) -->
            <section mdbScrollspyElement="scrollspy" id="Cashflow">
              <div class="form-section col-md-12">
                <h4 class="form-header">
                  <i class="fas fa-chart-line fa-fw me-2"></i>Cash Flow
                </h4>
                <!-- 3-column layout -->
                <div class="row row-cols-1 row-cols-md-3 gap-3 mt-3">

                  <!-- WALT -->
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">WALT (Entire Building)</label>
                    <div class="input-group input-group-sm">
                      <input type="text" class="form-control" readonly title="Current"
                        [value]="formatValue(rowDetails?.cashflow?.walt, 'Walt')"
                        [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('cashflow.walt', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('cashflow.walt', rowDetails).message || null : null" />
                      <span class="input-group-text bg-prior" title="Prior">{{
                        getFormattedPrior(rowDetails?.cashflow?.priorWalt, 'Walt') }}</span>
                      <span class="input-group-text bg-info text-white" title="Delta (Current - Prior)">
                        {{ getFormattedDelta(rowDetails?.cashflow?.walt, rowDetails?.cashflow?.priorWalt, 'Walt') }}
                      </span>
                    </div>
                  </div>

                  <!-- Stabilized Vacancy -->
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Stabilized Vacancy</label>
                    <div class="input-group input-group-sm">
                      <input type="text" class="form-control" readonly [value]="rowDetails?.cashflow?.vacancy " 
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('cashflow.vacancy', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('cashflow.vacancy', rowDetails).message || null : null" />
                    </div>
                  </div>

                  <!-- Collection Loss -->
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Collection Loss</label>
                    <div class="input-group input-group-sm">
                      <input type="text" class="form-control" readonly title="Current"
                        [value]="formatValue(rowDetails?.cashflow?.collectionLoss, 'CollectionLoss')"
                        [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('cashflow.collectionLoss', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('cashflow.collectionLoss', rowDetails).message || null : null" />
                      <span class="input-group-text bg-prior" title="Prior"
                        [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('cashflow.priorCollectionLoss', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('cashflow.collectionLoss', rowDetails).message || null : null">
                        {{ getFormattedPrior(rowDetails?.cashflow?.priorCollectionLoss, 'CollectionLoss') }}</span>
                      <span class="input-group-text bg-info text-white" title="Delta ((Current - Prior)/ Prior * 100)">
                        {{ getFormattedDelta(rowDetails?.cashflow?.collectionLoss,
                        rowDetails?.cashflow?.priorCollectionLoss, 'CollectionLoss') }}
                      </span>
                    </div>
                  </div>

                  <!-- Concessions -->
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Concessions/Tenant Allowance</label>
                    <div class="input-group input-group-sm">
                      <input type="text" class="form-control" readonly title="Current"
                        [value]="formatValue(rowDetails?.cashflow?.concessions, 'Concessions')"
                        [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('cashflow.concessions', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('cashflow.concessions', rowDetails).message || null : null" />
                      <span class="input-group-text bg-prior" title="Prior" [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('cashflow.priorConcessions', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('cashflow.priorConcessions', rowDetails).message || null : null">{{
                        getFormattedPrior(rowDetails?.cashflow?.priorConcessions, 'Concessions') }}</span>
                      <span class="input-group-text bg-info text-white" title="Delta ((Current - Prior)/ Prior * 100)">
                        {{ getFormattedDelta(rowDetails?.cashflow?.concessions, rowDetails?.cashflow?.priorConcessions,
                        'Concessions') }}
                      </span>
                    </div>
                  </div>

                  <!-- Downtime -->
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Downtime</label>
                    <div class="input-group input-group-sm">
                      <input type="text" class="form-control" readonly
                        [value]="formatValue(rowDetails?.cashflow?.downtime ,'Downtime')"
                        [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('cashflow.downtime', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('cashflow.downtime', rowDetails).message || null : null" />
                    </div>
                  </div>

                  <!-- NOI PSF -->
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Year 1 NOI</label>
                    <div class="input-group input-group-sm">
                      <input type="text" class="form-control" readonly [value]="rowDetails?.cashflow?.year1NOIPSF"
                        [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('cashflow.year1NOIPSF', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('cashflow.year1NOIPSF', rowDetails).message || null : null" />
                    </div>
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Year 1-5 Net Operating Income Yield</label>
                    <div class="input-group input-group-sm">
                      <input type="text" class="form-control" readonly [value]="getyear1To5NOI()" />
                    </div>
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Year 6-10 Net Operating Income Yield</label>
                    <div class="input-group input-group-sm">
                      <input type="text" class="form-control" readonly [value]="getyear6To10NOI()" />
                    </div>
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Net Cash Flow Amount</label>
                    <div class="input-group input-group-sm">
                      <input type="text" class="form-control" readonly [value]="rowDetails?.cashflow?.netCashFlowAmount" 
                        [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('cashflow.netCashFlowAmount', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('cashflow.netCashFlowAmount', rowDetails).message || null : null" />
                    </div>
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Real Estate Tax Growth Rate</label>
                    <div class="input-group input-group-sm">
                      <input type="text" class="form-control" readonly [value]="rowDetails?.cashflow?.realEstateTaxGrowthRate" 
                        [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('cashflow.realEstateTaxGrowthRate', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('cashflow.realEstateTaxGrowthRate', rowDetails).message || null : null" />
                    </div>
                  </div>

                </div>

                <div class="mt-4">
                  <div class="table-responsive" style="overflow-x: auto;">
                    <table class="table table-bordered text-center align-middle"
                      style="table-layout: fixed; min-width: 600px;">
                      <thead class="table-light">
                        <tr>
                          <th class="text-center">Year</th>
                          <th class="text-center">Implied Overall Rate</th>
                          <th class="text-center">Net Operating Income</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let year of [1,2,3,4,5,6,7,8,9,10,11]">
                          <td style="font-weight: 600;">Year {{ year }}</td>
                          <td class="text-end" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
                            <div [ngClass]="{ 'invalid-cell': dataLoaded && !getValidationStatus('cashflow.impliedOverallRate.year' + year, rowDetails).valid }"
                            [attr.title]="dataLoaded ? getValidationStatus('cashflow.impliedOverallRate.year' + year, rowDetails).message || null : null">
                            {{ rowDetails?.cashflow?.impliedOverallRate?.['year' + year] }}
                            </div>
                          </td>
                          <td class="text-end" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
                            <div [ngClass]="{ 'invalid-cell': dataLoaded && !getValidationStatus('cashflow.netOperationIncome.year' + year, rowDetails).valid }"
                            [attr.title]="dataLoaded ? getValidationStatus('cashflow.netOperationIncome.year' + year, rowDetails).message || null : null">
                            {{ rowDetails?.cashflow?.netOperationIncome?.['year' + year] }}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </section>

            <!-- Cashflow Living (New) -->
            <section mdbScrollspyElement="scrollspy" id="Cashflow-Living">
              <div class="form-section col-md-12">
                <h4 class="form-header"><i class="fas fa-home fa-fw me-2"></i>Cash Flow - Living</h4>
                <div class="d-flex flex-wrap gap-3 mt-3">
                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Non-Apartment Total / Sq.Ft</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.cashflowLiving?.nonApartmentTotalPSF"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('cashflowLiving.nonApartmentTotalPSF', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('cashflowLiving.nonApartmentTotalPSF', rowDetails).message || null : null" />
                  </div>
                </div>
              </div>
            </section>

            <!-- Cashflow Retail (New) -->
            <section mdbScrollspyElement="scrollspy" id="Cashflow-Retail">
              <div class="form-section col-md-12">
                <h4 class="form-header"><i class="fas fa-shopping-cart fa-fw me-2"></i>Cash Flow - Retail</h4>
                <div class="d-flex flex-wrap gap-3 mt-3">
                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Rolling 12 Months Sales / Sq.Ft</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.cashflowRetail?.rollingTwelveMonthsSalesPSF"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('cashflowRetail.rollingTwelveMonthsSalesPSF', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('cashflowRetail.rollingTwelveMonthsSalesPSF', rowDetails).message || null : null" />
                  </div>
                </div>
              </div>
            </section>
            
            <!-- Revenue and Expense -->
            <section mdbScrollspyElement="scrollspy" id="Revenue-and-Expense">
              <div class="form-section col-md-12">
                <h4 class="form-header">
                  <i class="fas fa-money-bill-wave fa-fw me-2"></i>Revenue and Expense
                </h4>
                <div class="table-responsive mt-3">
                  <table class="table table-bordered align-middle valuation-summary-table">
                    <thead class="table-light">
                      <tr>
                        <th class="text-start px-3 py-2">Field</th>
                        <th class="text-end px-3 py-2">Year One</th>
                        <th class="text-end px-3 py-2">Stabilized Year</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of revenueAndExpenseRows">
                        <td class="px-3 py-2">{{ row.label }}</td>
                        <td class="px-3 py-2 text-end">
                          <input
                            type="text"
                            class="form-control form-control-sm revenue-expense-input"
                            readonly
                            [value]="row.yearOne"
                            [ngClass]="{
                              'is-invalid': dataLoaded && !getValidationStatus(row.yearOneValidationKey, rowDetails).valid,
                              'text-end': isNumericOrCurrencyDisplay(row.yearOne),
                              'text-start': !isNumericOrCurrencyDisplay(row.yearOne)
                            }"
                            [attr.title]="dataLoaded ? getValidationStatus(row.yearOneValidationKey, rowDetails).message || null : null" />
                        </td>
                        <td class="px-3 py-2 text-end">
                          <input
                            type="text"
                            class="form-control form-control-sm revenue-expense-input"
                            readonly
                            [value]="row.stabilizedYear"
                            [ngClass]="{
                              'is-invalid': dataLoaded && !getValidationStatus(row.stabilizedYearValidationKey, rowDetails).valid,
                              'text-end': isNumericOrCurrencyDisplay(row.stabilizedYear),
                              'text-start': !isNumericOrCurrencyDisplay(row.stabilizedYear)
                            }"
                            [attr.title]="dataLoaded ? getValidationStatus(row.stabilizedYearValidationKey, rowDetails).message || null : null" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </section>

            <!-- Assumptions-->
            <section mdbScrollspyElement="scrollspy" id="Assumptions">
              <div class="form-section col-md-12">
                <h4 class="form-header"><i class="fas fa-cogs fa-fw me-2"></i>Assumptions</h4>
                <div class="d-flex flex-wrap gap-3 mt-3">
                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Market Inflation Years 1-5</label>
                    <div class="input-group input-group-sm">
                      <input type="text" class="form-control" readonly title="Current"
                        [value]="formatValue(rowDetails?.assumptions?.marketInflationYears1_5, 'MarketInflationYears')"
                        [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('assumptions.marketInflationYears1_5', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('assumptions.marketInflationYears1_5', rowDetails).message || null : null" />
                      <span class="input-group-text" style="background-color:#e9ecef;" title="Prior">
                        {{ getFormattedPrior(rowDetails?.assumptions?.priorMarketInflationYears1_5,
                        'MarketInflationYears') }}
                      </span>
                      <span class="input-group-text bg-info text-white" title="Delta ((Current - Prior)/ Prior * 100)">
                        {{ getFormattedDelta(rowDetails?.assumptions?.marketInflationYears1_5,
                        rowDetails?.assumptions?.priorMarketInflationYears1_5, 'MarketInflationYears') }}
                      </span>
                    </div>
                  </div>
                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Expense Inflation Years 1-5</label>
                    <div class="input-group input-group-sm">
                      <input type="text" class="form-control" readonly title="Current"
                        [value]="formatValue(rowDetails?.assumptions?.expenseInflationYears1_5, 'ExpenseInflationYears')"
                        [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('assumptions.expenseInflationYears1_5', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('assumptions.expenseInflationYears1_5', rowDetails).message || null : null" />
                      <span class="input-group-text" style="background-color:#e9ecef;" title="Prior">
                        {{ getFormattedPrior(rowDetails?.assumptions?.priorExpenseInflationYears1_5,
                        'ExpenseInflationYears') }}
                      </span>
                      <span class="input-group-text bg-info text-white" title="Delta ((Current - Prior)/ Prior * 100)">
                        {{ getFormattedDelta(rowDetails?.assumptions?.expenseInflationYears1_5,
                        rowDetails?.assumptions?.priorExpenseInflationYears1_5, 'ExpenseInflationYears') }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <!-- Lease Expirations (New) -->
            <section mdbScrollspyElement="scrollspy" id="Lease-Expirations">
              <div class="form-section col-md-12">
                <h4 class="form-header"><i class="fas fa-calendar-alt fa-fw me-2"></i>Lease Expirations</h4>
                <div class="d-flex flex-wrap gap-4 mt-3">
                  <div class="flex-grow-1" style="min-width: 300px; max-width: 48%;">
                    <label class="form-label">Five Year Cumulative Expirations / Square Feet</label>
                    <input type="text" class="form-control form-control-sm" [readonly]="true"
                      [value]="rowDetails?.leaseExpirations?.fiveYearCumulativeExpirationsPSF"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('leaseExpirations.fiveYearCumulativeExpirationsPSF', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('leaseExpirations.fiveYearCumulativeExpirationsPSF', rowDetails).message || null : null" />
                  </div>
                </div>
              </div>
            </section>

            <!-- Leasing Assumptions-->
            <section mdbScrollspyElement="scrollspy" id="Leasing-Assumptions">
              <div class="form-section col-md-12">
                <h4 class="form-header"><i class="fas fa-cogs fa-fw me-2"></i>Leasing Assumptions</h4>
                <div class="d-flex flex-wrap gap-3 mt-3">
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Lease Type (Reimbursements)</label>
                    <div class="input-group input-group-sm">
                      <input type="text" class="form-control" readonly title="Current"
                        [value]="rowDetails?.leasingAssumptions?.leaseType"
                        [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('leasingAssumptions.leaseType', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('leasingAssumptions.leaseType', rowDetails).message || null : null" />
                    </div>
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Market Lease Term</label>
                    <div class="input-group input-group-sm">
                      <input type="text" class="form-control" readonly title="Current"
                        [value]="rowDetails?.leasingAssumptions?.marketLeaseTerm"
                        [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('leasingAssumptions.marketLeaseTerm', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('leasingAssumptions.marketLeaseTerm', rowDetails).message || null : null" />
                    </div>
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Renewal Probability</label>
                    <div class="input-group input-group-sm">
                      <input type="text" class="form-control" readonly title="Current"
                        [value]="rowDetails?.leasingAssumptions?.renewalProbability"
                        [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('leasingAssumptions.renewalProbability', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('leasingAssumptions.renewalProbability', rowDetails).message || null : null" />
                    </div>
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Market Leasing Tenant Improvements New Leases</label>
                    <div class="input-group input-group-sm">
                      <input type="text" class="form-control" readonly title="Current"
                        [value]="rowDetails?.leasingAssumptions?.marketLeasingTenantImprovementsNewLeases"
                        [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('leasingAssumptions.marketLeasingTenantImprovementsNewLeases', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('leasingAssumptions.marketLeasingTenantImprovementsNewLeases', rowDetails).message || null : null" />
                    </div>
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Market Leasing Commissions New Leases</label>
                    <div class="input-group input-group-sm">
                      <input type="text" class="form-control" readonly title="Current"
                        [value]="rowDetails?.leasingAssumptions?.marketLeasingCommissionsNewLeases"
                        [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('leasingAssumptions.marketLeasingCommissionsNewLeases', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('leasingAssumptions.marketLeasingCommissionsNewLeases', rowDetails).message || null : null" />
                    </div>
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Year 1 Tenant Improvements</label>
                    <div class="input-group input-group-sm">
                      <input type="text" class="form-control" readonly title="Current"
                        [value]="rowDetails?.leasingAssumptions?.year1TenantImprovements"
                        [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('leasingAssumptions.year1TenantImprovements', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('leasingAssumptions.year1TenantImprovements', rowDetails).message || null : null" />
                    </div>
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Year 1 Leasing Commissions</label>
                    <div class="input-group input-group-sm">
                      <input type="text" class="form-control" readonly title="Current"
                        [value]="rowDetails?.leasingAssumptions?.year1LeasingCommissions"
                        [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('leasingAssumptions.year1LeasingCommissions', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('leasingAssumptions.year1LeasingCommissions', rowDetails).message || null : null" />
                    </div>
                  </div>
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Free Rent (Months)</label>
                    <div class="input-group input-group-sm">
                      <input type="text" class="form-control" readonly title="Current"
                        [value]="rowDetails?.leasingAssumptions?.freeRent"
                        [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('leasingAssumptions.freeRent', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('leasingAssumptions.freeRent', rowDetails).message || null : null" />
                    </div>
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Expense Reimbursement (Total Amount)</label>
                    <div class="input-group input-group-sm">
                      <input type="text" class="form-control" readonly title="Current"
                        [value]="rowDetails?.leasingAssumptions?.expenseReimbursement"
                        [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('leasingAssumptions.expenseReimbursement', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('leasingAssumptions.expenseReimbursement', rowDetails).message || null : null" />
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <!-- Contract & Market Rent Information -->
            <section mdbScrollspyElement="scrollspy" id="Contract-Month-Rent">
              <div class="form-section col-md-12">
                <h4 class="form-header">
                  <i class="fas fa-file-invoice-dollar fa-fw me-2"></i>Contract & Market Rent Information
                </h4>
                <div class="d-flex flex-wrap gap-3 mt-3">
                  <!-- Avg. Monthly Rent / Sq.Ft Field -->
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Average Contract Rent</label>
                    <div class="input-group input-group-sm" style="min-width: 220px;">
                      <input type="text" class="form-control" readonly title="Current"
                        [value]="rowDetails?.contractMonthRent?.averageContractRentPSF"
                        [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('contractMonthRent.averageContractRentPSF', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('contractMonthRent.averageContractRentPSF', rowDetails).message || null : null" />
                      <span class="input-group-text text-nowrap" style="background-color:#e9ecef;" title="Prior">
                        {{getFormattedPrior(rowDetails?.contractMonthRent?.priorAverageContractRentPSF,'Average Contract
                        Rent')}}
                      </span>
                      <span class="input-group-text bg-info text-white text-nowrap" title="Delta (Current - Prior)">
                        {{ getDollarFormatted(getFormattedDelta(rowDetails?.contractMonthRent?.averageContractRentPSF,
                        rowDetails?.contractMonthRent?.priorAverageContractRentPSF, 'Average Contract Rent')) }}
                      </span>
                    </div>
                  </div>

                  <!-- Monthly Market Rent / Sq.Ft Field -->
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Annual Contract Rent (Total Amount)</label>
                    <div class="input-group input-group-sm" style="min-width: 220px;">
                      <input type="text" class="form-control" readonly title="Current"
                        [value]="rowDetails?.contractMonthRent?.annualContractRentTotal"
                        [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('contractMonthRent.annualContractRentTotal', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('contractMonthRent.annualContractRentTotal', rowDetails).message || null : null" />
                      <span class="input-group-text text-nowrap" style="background-color:#e9ecef;" title="Prior">
                        {{getFormattedPrior(rowDetails?.contractMonthRent?.priorAnnualContractRentTotal,
                        'Average Contract Rent Total')}}
                      </span>
                      <span class="input-group-text bg-info text-white text-nowrap" title="Delta (Current - Prior)">
                        {{ getDollarFormatted(getFormattedDelta(rowDetails?.contractMonthRent?.annualContractRentTotal,
                        rowDetails?.contractMonthRent?.priorAnnualContractRentTotal, 'Average Contract Rent Total')) }}
                      </span>
                    </div>
                  </div>

                  <!-- Average Monthly Rent Field -->
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Average Market Rent</label>
                    <div class="input-group input-group-sm" style="min-width: 220px;">
                      <input type="text" class="form-control" readonly title="Current"
                        [value]="rowDetails?.contractMonthRent?.averageMarketRentPSF"
                        [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('contractMonthRent.averageMarketRentPSF', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('contractMonthRent.averageMarketRentPSF', rowDetails).message || null : null" />
                      <span class="input-group-text text-nowrap" style="background-color:#e9ecef;" title="Prior">
                        {{getFormattedPrior(rowDetails?.contractMonthRent?.priorAverageMarketRentPSF,
                        'Average Market Rent') }}
                      </span>
                      <span class="input-group-text bg-info text-white text-nowrap" title="Delta (Current - Prior)">
                        {{ getDollarFormatted(getFormattedDelta(rowDetails?.contractMonthRent?.averageMarketRentPSF,
                        rowDetails?.contractMonthRent?.priorAverageMarketRentPSF, 'Average Market Rent')) }}
                      </span>
                    </div>
                  </div>

                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Annual Market Rent (Total Amount)</label>
                    <div class="input-group input-group-sm" style="min-width: 220px;">
                      <input type="text" class="form-control" readonly title="Current"
                        [value]="rowDetails?.contractMonthRent?.annualMarketRentTotal"
                        [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('contractMonthRent.annualMarketRentTotal', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('contractMonthRent.annualMarketRentTotal', rowDetails).message || null : null" />
                    </div>
                  </div>

                  <!-- C&W Projected Rent Field -->
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">C&W Projection Monthly Market Rent</label>
                    <div class="input-group input-group-sm" style="min-width: 220px;">
                      <input type="text" class="form-control" readonly title="Current"
                        [value]="getDollarFormatted(rowDetails?.contractMonthRent?.cwProjectionMonthlyMarketRent)" />
                      <!-- If you plan to add prior and delta for this, implement similarly -->
                      <!-- <span class="input-group-text text-nowrap" style="background-color:#e9ecef;" title="Prior">
                        Example: {{ rowDetails?.contractMonthRent?.priorCWProjectionMonthlyMarketRent }}
                      </span> -->
                      <!-- <span class="input-group-text bg-info text-white text-nowrap" title="Delta (Current - Prior)">
                        Example: {{ getFormattedDelta(rowDetails?.contractMonthRent?.cwProjectionMonthlyMarketRent, rowDetails?.contractMonthRent?.priorCWProjectionMonthlyMarketRent) }}
                      </span> -->
                    </div>
                  </div>

                  <!-- CR:MR Field -->
                  <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                    <label class="form-label">Contract Rent:Market Rent</label>
                    <div class="input-group input-group-sm" style="min-width: 220px;">
                      <input type="text" class="form-control" readonly title="Current"
                        [value]="rowDetails?.contractMonthRent?.crmr"
                        [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('contractMonthRent.crmr', rowDetails).valid }"
                        [attr.title]="dataLoaded ? getValidationStatus('contractMonthRent.crmr', rowDetails).message || null : null" />
                      <!-- Optionally add prior and delta here if required -->
                      <!-- <span class="input-group-text text-nowrap" style="background-color:#e9ecef;" title="Prior">
                        Prior value if available
                      </span>
                      <span class="input-group-text bg-info text-white text-nowrap" title="Delta (Current - Prior)">
                        Delta value if applicable
                      </span> -->
                    </div>
                  </div>
                </div>

                <!-- Market Occupancy Percent -->
                <div class="flex-grow-1" style="min-width: 250px; max-width: 32%;">
                  <label class="form-label">Market Occupancy Percent</label>
                  <div class="input-group input-group-sm" style="min-width: 220px;">
                    <input type="text" class="form-control" readonly title="Current"
                      [value]="rowDetails?.contractMonthRent?.marketOccupancyPercent"
                      [ngClass]="{ 'is-invalid': dataLoaded && !getValidationStatus('contractMonthRent.marketOccupancyPercent', rowDetails).valid }"
                      [attr.title]="dataLoaded ? getValidationStatus('contractMonthRent.marketOccupancyPercent', rowDetails).message || null : null" />
                  </div>
                </div>

              </div>
            </section>

            <!-- Valuation Summary -->
            <section mdbScrollspyElement="scrollspy" id="Valuation-Summary">
              <div class="form-section col-md-12">
                <h4 class="form-header">
                  <i class="fas fa-balance-scale fa-fw me-2"></i>Valuation Summary
                </h4>

                <!-- one mini-table per section -->
                <div *ngFor="let section of valuationSections" class="mt-3">

                  <!-- section title (for Yield, Direct, Revenue & Expense) -->
                  <div *ngIf="section.title" class="fw-semibold mb-2">
                    {{ section.title }}
                  </div>

                  <div class="table-responsive valuation-summary-wrapper">
                    <table class="table table-bordered align-middle valuation-summary-table">
                      <thead class="table-light">
                        <tr>
                          <th *ngFor="let col of valuationColumnDefs; let i = index"
                          [ngClass]="{ 'vs-col-label': i === 0, 'vs-col-scenario': i !== 0 }" class="text-center px-3 py-2">
                            {{ section.id == 'period' && i > 1 ? '' : col.headerName }}
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr *ngFor="let row of section.rows" style="vertical-align: middle;">

                          <td *ngFor="let col of valuationColumnDefs; let i = index" class="px-3 py-2 align-middle"
                            [style.width]="i === 0 ? '300px' : '280px'" [class.text-start]="i === 0"
                            [class.text-end]="i !== 0">

                            <!-- label column -->
                            <ng-container *ngIf="i === 0">
                              <span class="vs-label" [title]="row.label">
                                {{ row.label }}
                              </span>
                            </ng-container>

                            <!-- scenario columns -->
                            <ng-container *ngIf="i !== 0">

                              <!-- rows with current/prior/delta -->
                              <ng-container *ngIf="enhancedValuationRows.has(row.label); else defaultCell">
                                <div class="input-group input-group-sm d-flex justify-content-end w-100">
                                  <input
                                    type="text"
                                    class="form-control"
                                    readonly
                                    title="Current"
                                    [value]="row[col.field]"
                                    [ngClass]="{ 'is-invalid': dataLoaded && isValSummaryInvalid(row, col) }"
                                    [attr.title]="dataLoaded ? getValSummaryMessage(row, col) : null" />

                                  <span class="input-group-text text-nowrap" style="background-color: #e9ecef;"
                                    *ngIf="row[col.field + 'Prior'] !== undefined" title="Prior">
                                    {{ row[col.field + 'Prior'] }}
                                  </span>

                                  <span class="input-group-text text-nowrap bg-info text-white"
                                    *ngIf="row[col.field + 'Delta'] !== undefined" title="Delta (Current - Prior)">
                                    {{ row[col.field + 'Delta'] }}
                                  </span>
                                </div>
                              </ng-container>

                              <!-- plain cells -->
                              <ng-template #defaultCell>
                                <div [ngClass]="{ 'invalid-cell': dataLoaded && isValSummaryInvalid(row, col) }"
                                  [attr.title]="dataLoaded ? getValSummaryMessage(row, col) : null">
                                   {{exposureAndMarketingTimesValuationRows.has(row.label) && i < 2 ? formatValue(row[col.field], row.label) + ' Months' : formatValue(row[col.field], row.label) }} <!--  Months is harcoded as this is hardcoded in Data Capture -->
                                </div>
                              </ng-template>
                              
                            </ng-container>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

              </div>
            </section>            

            <!-- Valuation Comments (New) -->
            <section mdbScrollspyElement="scrollspy" id="Valuation-Comments">
              <div class="form-section col-md-12">
                <h4 class="form-header"><i class="fas fa-comments fa-fw me-2"></i>Valuation Comments</h4>
                <div class="d-flex flex-wrap gap-4 mt-3">
                  <div class="col-md-12">
                    <label class="form-label">Appraisal Value Comments</label>
                    <textarea class="form-control form-control-sm" rows="4"
                      [readonly]="true">{{ rowDetails?.valuationComments?.appraisalValueComments }}</textarea>
                  </div>
                  <div class="col-md-12">
                    <label class="form-label">Market Value Comments</label>
                    <textarea class="form-control form-control-sm" rows="4"
                      [readonly]="true">{{ rowDetails?.valuationComments?.marketValueComments }}</textarea>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <div class="col-md-2">
          <div title="{{ !isFormValid() ? 'Please correct validation errors to enable the button' : '' }}">
            <div mdbDropdown class="btn-group main-btn">
              <button type="button" class="btn btn-primary dropdown-toggle exportDropdown" mdbDropdownToggle
                aria-expanded="false" [disabled]="!isFormValid()">
                Ready for Client
              </button>
              <ul mdbDropdownMenu class="dropdown-menu">
                <li><a class="dropdown-item" (click)="approveSelected()">Yes</a></li>
                <li><a class="dropdown-item" (click)="rejectSelected()">No</a></li>
              </ul>
            </div>
          </div>

          <div id="scrollspy" class="sticky-top">
            <ul mdbScrollspy="scrollspy" class="nav flex-column nav-pills menu-sidebar">
              <li class="nav-item" *ngFor="let section of sectionList">
                <a [mdbScrollspyLink]="section.id" [scrollIntoView]="true"
                  class="nav-link d-flex justify-content-between align-items-center">
                  <span>{{ section.label }}</span>
                  <span *ngIf="sectionErrorCounts[section.id] > 0 && dataLoaded" class="badge ms-2"
                    title="{{ sectionErrorCounts[section.id] }} error(s) in this section">
                    ⚠️
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <app-save-modal-popup #approvalModal (confirmAction)="handleModalAction($event)"></app-save-modal-popup>
  </div>
</ng-container>
<ng-template #loading>
  <div class="d-flex flex-column justify-content-center align-items-center" style="height: 100vh;">
    <div class="spinner-grow text-danger" role="status">
      <span role="status" aria-hidden="true"></span>
    </div>
  </div>
</ng-template>
